<template>
  <Card tag="form" variant="widget" class="model-template-mutate-template" @submit.prevent="$emit('submit')">
    <template #header>
      <div class="card-v2__title">{{ $tc('template', 1) }}</div>
    </template>

    <template #default>
      <div class="model-template-mutate-template__input">
        <FieldRenderer v-for="item in fields.default" :item="item" :value="value" />

        <CustomFields
          :key="fields.slots.map(s => s.slotKey).join(',')"
          v-model="value.customFields"
          :schema="customFieldSchemas"
          :data="data"
          :placement="placement"
          @remove="$ev => removeCustomField($ev)"
          :validator="validator"
          validator-prefix="customFields"
          :disabledFields="$path('metadata.disabledFields.modelTemplate', item)"
        >
          <template v-for="item in fields.slots" v-slot:[item.slotKey]>
            <FieldRenderer :item="item" :value="value" />
          </template>
        </CustomFields>
      </div>
    </template>
  </Card>
</template>

<script>
import { mapState } from 'vuex'
import { i18n } from '@/i18n'
import { assocPath } from 'ramda'
import Card from '@/components/Card-v2'
import CustomFields from '@kvass/custom-fields'
import FieldRenderer from '@/components/ModelTemplate/StepsFields/FieldRenderer.vue'
import { InputComponent } from 'vue-elder-input'

const meta = {
  order: 0,
  id: 'template',
  label: i18n.tc('template', 1),
}

export { meta }
export default {
  props: {
    data: Object,
    value: Object,
    labels: Object,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      placement: ['template', 'modelTemplate:template'],
    }
  },

  computed: {
    ...mapState('ModelTemplate', ['item']),
  },
  methods: {
    removeCustomField(item) {
      this.value.customFields = assocPath(item.key.split('.'), null, this.value.customFields)
      this.value.customFieldsConfig = this.value.customFieldsConfig.filter(c => c.source !== item.source)
    },
  },
  components: {
    Card,
    CustomFields,
    FieldRenderer,
    InputComponent,
  },
}
</script>

<style lang="scss">
.model-template-mutate-template {
  max-width: 900px;
  margin: auto;

  $cols: 2;

  .elder-loader {
    flex-grow: 0;
  }

  &__header {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    align-items: start;
    justify-content: space-between;
    padding: var(--card-spacing);
    padding-bottom: 0;

    p {
      margin: 0;
    }
  }

  & > .card-v2 {
    &__header {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }

  &__input {
    display: grid;
    grid-template-columns: repeat($cols, 1fr);
    grid-gap: $form-gap;

    padding: var(--card-spacing);

    // [data-field='name'],
    // [data-field='themes'] {
    //   grid-column-end: span 2;
    // }
  }

  .custom-fields {
    grid-column-end: span $cols;
  }
}
</style>
